import { render, staticRenderFns } from "./myReferral.vue?vue&type=template&id=08247fc9&scoped=true"
import script from "./myReferral.vue?vue&type=script&lang=js"
export * from "./myReferral.vue?vue&type=script&lang=js"
import style0 from "./myReferral.vue?vue&type=style&index=0&id=08247fc9&prod&scoped=true&lang=css"
import style1 from "./myReferral.vue?vue&type=style&index=1&id=08247fc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08247fc9",
  null
  
)

export default component.exports